import { render, staticRenderFns } from "./ContinueIssuance.vue?vue&type=template&id=84ef9448&"
import script from "./ContinueIssuance.vue?vue&type=script&lang=js&"
export * from "./ContinueIssuance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports